module.exports = __webpack_public_path__ + "img/icon_map_108_on_111.afb90ada.png";